/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-fetch': {
    width: 10,
    height: 9,
    viewBox: '0 0 10 9',
    data: '<defs><path pid="0" d="M5.143 0a4.346 4.346 0 0 1 0 8.692.5.5 0 1 1 0-1A3.346 3.346 0 1 0 2.12 2.91l.731-.224a.5.5 0 0 1 .59.248l.035.084a.5.5 0 0 1-.249.59l-.083.034-1.913.585a.5.5 0 0 1-.59-.249l-.034-.083-.585-1.913a.5.5 0 0 1 .922-.376l.034.084.24.788A4.348 4.348 0 0 1 5.143 0z" id="svgicon-icon-fetch-a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon-icon-fetch-b" _fill="#fff"><use xlink:href="#svgicon-icon-fetch-a"/></mask><use _fill="#376F99" fill-rule="nonzero" xlink:href="#svgicon-icon-fetch-a"/><path pid="1" _fill="#376F99" mask="url(#svgicon-icon-fetch-b)" d="M0-1h10V9H0z"/></g>'
  }
})
